import MemberSignUpVue from '@/views/member/sign-up/sign-up.vue';

const basePath = '/member/sign-up';
const role = 'member'; // 角色身份

export const M_SIGN_UP_INDEX = 'm-sign-up';
export const M_SIGN_UP_SUCCESS = 'm-sign-up-success';
export const M_SIGN_UP_FAIL = 'm-sign-up-fail';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: MemberSignUpVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: M_SIGN_UP_INDEX,
      props: true,
      component: () => import(
        /* webpackChunkName: "sign-up" */
        `@/views/${role}/sign-up/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/success`,
      name: M_SIGN_UP_SUCCESS,
      props: true,
      component: () => import(
        /* webpackChunkName: "sign-up-success" */
        `@/views/${role}/sign-up/success.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/fail`,
      name: M_SIGN_UP_FAIL,
      component: () => import(
        /* webpackChunkName: "sign-up-fail" */
        `@/views/${role}/sign-up/fail.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
